"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Failed = exports.InUse = exports.Stopped = exports.Prepared = exports.NotSupported = exports.NotRequested = exports.Mp4WsGroup = void 0;
const state_flow_1 = require("@video/state-flow");
const mp4_ws_1 = require("../../drivers/video-element/mp4-ws");
const state_flow_2 = require("../state-flow");
const common_1 = require("./common");
//#endregion
//#region Group Declaration
exports.Mp4WsGroup = state_flow_2.PlayerStateFlow.registerGroup("mp4ws").bootstrap(() => {
    return (0, exports.NotRequested)({
        driverFormat: "mp4-ws",
        priority: -1,
        support: "",
        timeout: 0,
        features: {
            sourceQuality: false,
            forcedQuality: true,
            autoBitrate: false,
        },
    });
});
//#endregion
//#region Signals Handlers
function loadDriver(groups, signal) {
    const [priority, config] = (0, common_1.findDriver)(mp4_ws_1.Mp4WsDriver, signal.options.drivers);
    if (priority === -1) {
        return state_flow_1.Result.ignore();
    }
    const support = (0, common_1.checkDriverSupport)(mp4_ws_1.Mp4WsDriver, groups.host.element, groups.manifest.json);
    if (support === "hmp") {
        return (0, exports.Prepared)({ ...groups.mp4ws, priority, support, timeout: config.timeout });
    }
    return (0, exports.NotSupported)({ ...groups.mp4ws, priority, support });
}
function unloadDriver(groups, signal) {
    const [priority, _] = (0, common_1.findDriver)(mp4_ws_1.Mp4WsDriver, signal.options.drivers);
    if (priority !== -1) {
        return state_flow_1.Result.ignore();
    }
    return (0, exports.NotRequested)({ ...groups.mp4ws, priority });
}
function updateSupportHostStatus(groups, signal) {
    const support = (0, common_1.checkDriverSupport)(mp4_ws_1.Mp4WsDriver, signal.host, groups.manifest.json);
    if (support === "hmp") {
        return (0, exports.Prepared)({ ...groups.mp4ws, support });
    }
    return (0, exports.NotSupported)({ ...groups.mp4ws, support });
}
function updateSupportManifestStatus(groups, signal) {
    const support = (0, common_1.checkDriverSupport)(mp4_ws_1.Mp4WsDriver, groups.host.element, signal.manifest);
    if (support === "hmp") {
        return (0, exports.Prepared)({ ...groups.mp4ws, support });
    }
    return (0, exports.NotSupported)({ ...groups.mp4ws, support });
}
// function nativeHlsLoad({ nativeHls, manifest }: Groups, signal: Signals["nativeHlsLoad"]): StateResult<Props> {
//   const format = manifest.json?.formats[nativeHls.driverFormat];
//   if (format == null) {
//     return NotSupported({ ...nativeHls });
//   }
//
//   return Loaded({ ...nativeHls });
// }
// function requestDriver({ nativeHls }: Groups, signal: Signals["requestDriver"]): StateResult<Props> {
//   return NotSupported(nativeHls);
// }
//#endregion
//#region States Declarations
exports.NotRequested = exports.Mp4WsGroup.registerState("NotRequested", {
    optionsApply: loadDriver,
});
exports.NotSupported = exports.Mp4WsGroup.registerState("NotSupported", {
    optionsApply: unloadDriver,
    manifestUpdate: updateSupportManifestStatus,
    hostElementAttach: updateSupportHostStatus,
});
exports.Prepared = exports.Mp4WsGroup.registerState("Prepared", {
    optionsApply: unloadDriver,
    manifestUpdate: updateSupportManifestStatus,
    hostElementAttach: updateSupportHostStatus,
    driverSwitch: (g, s) => {
        const res = (0, common_1.checkDriverSwitchRestrictions)(g);
        if (res.kind === state_flow_1.ResultKind.Rejected) {
            return res;
        }
        return s.driver === exports.Mp4WsGroup.name ? (0, exports.InUse)(g.mp4ws) : g.mp4ws;
    },
});
exports.Stopped = exports.Mp4WsGroup.registerState("Stopped", {
    optionsApply: unloadDriver,
    hostElementAttach: updateSupportHostStatus,
    driverSwitch: (g, s) => {
        const res = (0, common_1.checkDriverSwitchRestrictions)(g);
        if (res.kind === state_flow_1.ResultKind.Rejected) {
            return res;
        }
        return s.driver === exports.Mp4WsGroup.name ? (0, exports.InUse)(g.mp4ws) : g.mp4ws;
    },
});
exports.InUse = exports.Mp4WsGroup.registerState("InUse", {
    optionsApply: () => state_flow_1.Result.reject("driver is in use"),
    hostElementDetach: () => state_flow_1.Result.reject("host element is in use of Mp4Ws"),
    // detachHostElement: (g) => Prepared(g.nativeHls),
    driverSwitch: (g, s) => {
        const res = (0, common_1.checkDriverSwitchRestrictions)(g);
        if (res.kind === state_flow_1.ResultKind.Rejected) {
            return res;
        }
        return s.driver === exports.Mp4WsGroup.name ? g.mp4ws : (0, exports.Stopped)(g.mp4ws);
    },
});
exports.Failed = exports.Mp4WsGroup.registerState("Failed", {
    optionsApply: unloadDriver,
});
//#endregion
//# sourceMappingURL=mp4-ws.js.map